import { PATH_DASHBOARD } from '@app/routes/paths';

// App Configs
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.onBoarding;
// ----------------------------------------------------------------------

// Api Configs
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? '';
export const IMAGE_BASE_URL = '';
export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT ?? 0;
// ----------------------------------------------------------------------

export const COMPANY_NAME = `Chef's`;

// ----------------------------------------------------------------------

export const NAV = {
  W_DASHBOARD: 280,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
};

// ----------------------------------------------------------------------
